import { prop, required } from '@rxweb/reactive-form-validators';

export class ReelModel {
	@required()
	name: string;

	@required()
	type: string;

	@prop({name: 'groups_id'})
	@required()
	groups_id: string;

	@required()
	reel_categories_id: string;

	@prop({name: 'active'})
    active: string;

	@prop({name: 'layouts_id'})
    layouts_id: number;

	@prop({name: 'client_id'})
    client_id: any;

	@prop({name: 'screenId'})
    screenId: number;

	@prop({name: 'layoutIdScreenId'})
    layoutIdScreenId: string;

}
